import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { useFeatureFlags } from '../../contexts/FeatureFlagProvider';

type FeatureFlagRouteProps = {
  children: ReactElement;
  flag: keyof ReturnType<typeof useFeatureFlags>;
};

// Keeps a lazy route's chunk from ever being fetched when its flag is off, by never mounting
// the lazy boundary passed in as children.
function FeatureFlagRoute({ children, flag }: FeatureFlagRouteProps): ReactElement {
  const featureFlags = useFeatureFlags();

  if (!featureFlags[flag]) {
    return <Navigate replace to="/" />;
  }

  return children;
}

export default FeatureFlagRoute;
